import React, { useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import ChatBot from 'react-simple-chatbot';
import styled from 'styled-components';
import Cookies from 'js-cookie';

import getTheme from './chatModal/chatbotTheme'
import getConfig from './chatModal/chatbotConfig';
import PrivacyPolicy from './chatModal/PrivacyPolicy';
import InformationForm from './chatModal/InformationForm';
import Timestamp from './chatModal/Timestamp';
import SpeakWithAgentButton from './chatModal/SpeakWithAgentButton';
import CompanyInformationForm from './chatModal/CompanyInformationForm';
import Header from './chatModal/ChatHeader';

const ChatBotImg = styled.img`
  width: 100%;
  height: 100%;
`

const ChatBotDiv = styled.div`
  width: 80px;
  height: 80px;
  position: absolute;
  bottom: 3.8rem;
  right: 2.5rem;
  cursor: pointer;
`

const MedicardChatBot = ({ customPlugin }) => {
  const [opened, setOpened] = useState(false); //for minimizing chatbot
  const [isLiveChatinSession, setIsLiveChatinSession] = useState(true);
  const theme = getTheme();
  const config = getConfig();

  useEffect(() => {
    if (Cookies.get('_genesys.widgets.webchat.state.purecloud-v2-sockets.JWtoken')) {
      setIsLiveChatinSession(false);
    }
  }, [])

  const handleInLiveChatInSession = () => {
    setIsLiveChatinSession(!isLiveChatinSession)
    setOpened(!opened);
  }

  const handleOpenChatBot = () => {
    setOpened(!opened)
  }

  const steps = [
    {
      id: 'privacyPolicy',
      component: <PrivacyPolicy />,
      waitAction: true,
      trigger: 'informationForm',
      replace: true
    },
      // INITIAL FORM START
    {
      id: 'informationForm',
      component: <InformationForm customPlugin={customPlugin} />,
      waitAction: true,
      replace: true,
      trigger: () => {
        if(window._genesys.widgets.webchat.userData.chooseAnswer === 'Yes'){
          return "memberCategoriesQuestion"
        }else{
          return "nonMemberCategoriesQuestion"
        }
      },
    },
    //MEMBER CHAT FLOW
    {
      id: "memberCategoriesQuestion",
      component: <div><p>Categories:</p></div>,
      trigger: 'memberCategoriesOptions'
    },
    {
      id: 'memberCategoriesOptions',
      options: [
        { value: 'Schedule_an_appointment_in_Medicard_clinics', label: 'Schedule an appointment in Medicard clinics', trigger: 'Schedule_an_appointment_in_Medicard_clinics_autoreply' },
        { value: 'Request_approval_for_Laboratory_Diagnostic_test', label: 'Request approval for Laboratory/Diagnostic test', trigger: 'Request_approval_for_Laboratory_Diagnostic_test_Clicked' },
        { value: 'Request_approval_for_Consultation', label: 'Request approval for Consultation', trigger: 'Request_approval_for_Consultation_Clicked' },
        { value: 'Membership_coverage', label: 'Membership Coverage', trigger: 'Autoreply_Clicked' },
        { value: 'Membership_information_and_utilization', label: 'Membership information and utilization', trigger: 'Autoreply_Clicked' },
        { value: 'Online_Consultation', label: 'Online Consultation', trigger: 'Online_Consultation_Clicked' },
        { value: 'Medicard_Number_Inquiry', label: 'Medicard Number Inquiry', trigger: 'Medicard_Number_Inquiry_Clicked' },
        { value: 'Inpatient_Inquiry_and_concerns', label: 'Inpatient Inquiry and concerns', trigger: 'Inpatient_Inquiry_and_concerns_Clicked' },
        { value: 'Dental_Coverage_and_Concern', label: 'Dental Coverage and Concern', trigger: 'Dental_Autoreply_Clicked' },
        { value: 'File_for_Reimbursement', label: 'File for Reimbursement', trigger: 'File_for_Reimbursement_Clicked' },
        { value: 'Accredited_Providers', label: 'Accredited Providers', trigger: 'Accredit_Providers_Clicked' },
        { value: 'Marketing', label: 'Marketing', trigger: 'marketingCategories' },
      ],
      placeholder: "Choose an answer"
    },
    {
      id: 'backButtonMember',
      options: [{value: 'backButtonMember', label: 'Back', trigger: 'memberCategoriesQuestion'}]
    },
    //Schedule auto-reply
    {
      id: "Schedule_an_appointment_in_Medicard_clinics_autoreply",
      component: <div  className="bot-message-component"  >You may book a visit in our free-standing clinics at <a target="_blank" rel="noopener noreferrer"  href="https://fsc.medicardphils.com">https://fsc.medicardphils.com</a>.<br /><Timestamp /></div>,
      asMessage: true,
      trigger: "backButtonMember"
    },
    //Connect to genesys for lab/diag inquiry
    {
      id: "Request_approval_for_Laboratory_Diagnostic_test_Clicked",
      component: <div className="bot-message-component">You may request for out-patient approval of <br/>laboratory & diagnostic procedures at <a target="_blank" rel="noopener noreferrer"  href="https://webportal.medicardphils.com/OnlineLOA">https://webportal.medicardphils.com/OnlineLOA</a> or you may download MediCard GO Member App at Apple Store/Google Play/Huawei AppGallery.<br /><Timestamp /></div>,
      asMessage: true,
      trigger: "backButtonMember"
    },
    //Connect to genesys for consultation inquiry
    {
      id: "Request_approval_for_Consultation_Clicked",
      component: <div className="bot-message-component">For consultation request, you may download MediCard GO Member App at Apple Store/Google Play/Huawei AppGallery.<br /><Timestamp /></div>,
      asMessage: true,
      trigger: "backButtonMember"
    },
    //Connect to genesys for membership coverage
    {
      id: "Membership_coverage_Clicked",
      component: <div>Please wait, we will connect you to our agent...<br /><Timestamp /></div>,
      asMessage: true,
      trigger: "Membership_coverage_Button"
    },
    //Connect to genesys for membership information and util
    {
      id: "Membership_information_and_utilization_Clicked",
      component: <div>Please wait, we will connect you to our agent...<br /><Timestamp /></div>,
      asMessage: true,
      trigger: "Membership_information_and_utilization_Button"
    },
    //Connect to genesys for online consultation
    {
      id: "Online_Consultation_Clicked",
      component: <div className="bot-message-component">For consultation request, you may download MediCard GO Member App at Apple Store/Google Play/Huawei AppGallery.<br /><Timestamp /></div>,
      asMessage: true,
      trigger: "backButtonMember"
    },
    //Connect to genesys for inpatient inquiry
    {
      id: "Inpatient_Inquiry_and_concerns_Clicked",
      component: <div>Please wait, we will connect you to our agent...<br /><Timestamp /></div>,
      asMessage: true,
      trigger: "Inpatient_Inquiry_and_concerns_Button"
    },
    //Connect to genesys for dental coverage
    {
      id: "Dental_Coverage_and_Concern_Clicked",
      component: <div>Please wait, we will connect you to our agent...<br /><Timestamp /></div>,
      asMessage: true,
      trigger: "Dental_Coverage_and_Concern_Button"
    },
    //File for reimbursement autoreply
    {
      id: "File_for_Reimbursement_Clicked",
      component: <div>For reimbursement concerns, you may email at <a href="mailto:reimbursementservices@medicardphils.com">reimbursementservices@medicardphils.com</a>.<br /><Timestamp /></div>,
      asMessage: true,
      trigger: "backButtonMember"
    },
    //Accredited providers autoreply
    {
      id: "Accredit_Providers_Clicked",
      component: <div  className="bot-message-component"  >You may see the list of our accredited providers at <a target="_blank" rel="noopener noreferrer"  href="https://www.medicardphils.com/accredited-providers">https://www.medicardphils.com/accredited-providers</a>. Thank You. <br /><br /><p>For Provider accreditation, email us at <a href="mailto:provider@medicardphils.com">provider@medicardphils.com</a>.</p><Timestamp /></div>,
      asMessage: true,
      trigger: "backButtonMember"
    },
    //Membership information and utilization, Membership coverage, Dental Coverage and Concern autoreply
    {
      id: "Autoreply_Clicked",
      component: <div className="bot-message-component">Hi, good day. Please note that coverage differs from one member/company to another. This depends on plan availed of by said member/company. You may verify with your HRD or at our 24/7 call center hotlines: <b>(02) 8841-8080</b>.<br /><br />
      <p>
        {/* Smart InfoText (no calls/text only) – <b>0908-884-1814</b><br /> */}
      Smart Toll free number outside Metro Manila: <br/><b>1-800-1888-9001</b><br /><br/>
      {/* Globe InfoText (no calls/text only) – <b>0917-851-2648</b><br /> */}
      Globe/TM Toll free number outside Metro Manila: <br/><b>1-800-8-944-8400</b><br /><br/>
      {/* Sun Infotext (no calls/text only) – <b>0925-714-0618</b> */}
      </p><Timestamp /></div>,
      asMessage: true,
      trigger: "backButtonMember"
    },
    {
      id: "Dental_Autoreply_Clicked",
      component: <div className="bot-message-component">Hi, good day. Please note that coverage differs from one member/company to another. This depends on plan availed of by said member/company. You may verify with your HRD or at our 24/7 call center hotlines: <b>(02) 8841-8080</b>.<br /><br />
      <p>Smart  – <b>0928-504-8759</b>    (from 8:00am-7:00pm) <br />
      {/* Globe – <b>0906-063-9105</b> */}
      </p><Timestamp /></div>,
      asMessage: true,
      trigger: "backButtonMember"
    },
    {
      id: "marketingCategories",
      component: <div><p>Categories:</p></div>,
      trigger: 'marketingOptions'
    },
    {
      id: 'marketingOptions',
      options: [
        { value: 'Partnerships', label: 'Partnerships', trigger: 'Marketing Email to Partnerships' },
        { value: 'Sponsorships', label: 'Sponsorships', trigger: 'Marketing Email to Sponsorships' },
        { value: 'Promos', label: 'Promos', trigger: 'Marketing Email to Promos' },
        { value: 'Events', label: 'Events', trigger: 'Marketing Email to Events' },
      ],
      placeholder: "Choose an answer"
    },
    {
      id: "Marketing Email to Sponsorships",
      component: <div className="bot-message-component"  >
      You may send us an email at <a href="mailto:marketing@medicardphils.com">marketing@medicardphils.com</a>. <br/><br/>
      Stay updated by following us on Facebook at Medicard Philippines and on Instagram at @medicardphils.<br /><Timestamp />
      </div>,
      asMessage: true,
      trigger: "Sponsorships_Clicked"
    },
    {
      id: "Marketing Email to Partnerships",
      component: <div className="bot-message-component"  >
      You may send us an email at <a href="mailto:marketing@medicardphils.com">marketing@medicardphils.com</a>. <br/><br/>
      Stay updated by following us on Facebook at Medicard Philippines and on Instagram at @medicardphils.<br /><Timestamp />
      </div>,
      asMessage: true,
      trigger: "Partnerships_Clicked"
    },
    {
      id: "Sponsorships_Clicked",
      options: [{value: 'Contact_Us_Chat_Button', label: 'Chat with an Agent', trigger: 'Sponsorships_Button'}]
    },
    {
      id: "Partnerships_Clicked",
      options: [{value: 'Contact_Us_Chat_Button', label: 'Chat with an Agent', trigger: 'Partnerships_Button'}]
    },
    //NON-MEMBER CHAT FLOW
    {
      id: "nonMemberCategoriesQuestion",
      component: <div>Looking for healthcare coverage?<br /><Timestamp /></div>,
      asMessage: true,
      trigger: "nonMemberCategoriesRender"
    },
    {
      id: "nonMemberCategoriesRender",
      component: <div><p>Categories:</p></div>,
      trigger: 'nonMemberCategoriesOptions'
    },
    {
      id: 'nonMemberCategoriesOptions',
      options: [
        { value: 'Corporate and SME Plans', label: 'Corporate and SME Plans', trigger: 'Corporate_and_SME_Plans' },
        { value: 'Individual_and_Family', label: 'Individual and Family', trigger: 'Individual_and_Family_Header' },
        { value: 'OFW Beneficiaries', label: 'OFW Beneficiaries', trigger: 'OFW Beneficiaries' },
        { value: 'Medicard Select', label: 'Medicard Select', trigger: 'Medicard_Select' },
        { value: 'Prepaid Plans (non full-HMO)', label: 'Prepaid Plans (non full-HMO)', trigger: 'Prepaid Plans (non full-HMO) Header' },
        { value: 'Contact_Us', label: 'Contact Us', trigger: 'Contact_Us_Categories' },
      ],
      placeholder: "Choose an answer"
    },
    {
      id: 'backButtonNonMember',
      options: [{value: 'backButtonNonMember', label: 'Back', trigger: 'nonMemberCategoriesRender'}]
    },
    // INDIVIDUAL AND FAMILY
    {
      id: "Individual_and_Family_Header",
      component: <div>Below are the plans for yourself and your family:<br /><Timestamp /></div>,
      asMessage: true,
      trigger: "Individual_and_Family_Categories"
    },
    {
      id: "Individual_and_Family_Categories",
    component: <div><p>Categories:</p></div>,
      trigger: 'Individual_and_Family_Options'
    },
    {
      id: 'Individual_and_Family_Options',
      options: [
        { value: 'Individual_and_Family', label: 'Individual and Family', trigger: 'Individual_and_Family' },
        { value: 'VIP', label: 'VIP', trigger: 'VIP' },
      ],
      placeholder: "Choose an answer"
    },
    {
      id: "Individual_and_Family",
      component: <div className="bot-message-component"  style={{textAlign: "left", textJustify:"inner-word"}}><p style={{fontWeight: 'bold',  textAlign: "left"}}>Individual and Family</p>
      These plans are for individuals and families who want to have coverage for hospitalization, 
      out-patient care, preventive healthcare, emergency, and dental care. 
      Plan starts at Php 10,739 per member. <br /> <br />
      Get to know more about these plans at <a target="_blank" rel="noopener noreferrer"  href="https://www.medicardphils.com/healthcare-programs/standard">https://www.medicardphils.com/healthcare-programs/standard</a>. 
      <br/><br/>Disclaimer: Maternity is not covered. <br /><Timestamp />
      </div>,
      asMessage: true,
      trigger: "Individual_and_Family_Clicked"
    },
    {
      id: "Individual_and_Family_Clicked",
      options: [{value: 'Individual_and_Family_Button', label: 'Chat with an Agent', trigger: 'Individual_and_Family_Button'}]
    },
    {
      id: "VIP",
      component: <div className="bot-message-component"  style={{textAlign: "left", textJustify:"inner-word"}}><p style={{fontWeight: 'bold', textAlign: "left"}}>VIP</p>
      MediCard VIP plans are for those who want to have more comprehensive healthcare coverage. 
      On top of the extensive hospitalization, out-patient, preventive healthcare, emergency, and dental care coverage, 
      MediCard VIP plans also come with healthcare assistance during an emergency abroad. 
      <br /> <br />
      Get to know more about the plan at <a target="_blank" rel="noopener noreferrer"  href="https://www.medicardphils.com/healthcare-programs/vip">https://www.medicardphils.com/healthcare-programs/vip</a>. <br /><Timestamp />
      </div>,
      asMessage: true,
      trigger: "VIP_Clicked"
    },
    {
      id: "VIP_Clicked",
      options: [{value: 'VIP_Button', label: 'Chat with an Agent', trigger: 'VIP_Button'}]
    },

    // BUDGET FRIENDLY PLANS
    {
      id: "Prepaid Plans (non full-HMO) Header",
      component: <div>From unli check-ups to discounted labs, choose from our prepaid plans below:<br /><Timestamp /></div>,
      asMessage: true,
      trigger: "Prepaid Plans (non full-HMO) Categories"
    },
    {
      id: "Prepaid Plans (non full-HMO) Categories",
      component: <div><p>Categories:</p></div>,
      trigger: 'Prepaid Plans (non full-HMO) Options'
    },
    {
      id: 'Prepaid Plans (non full-HMO) Options',
      options: [
        { value: 'RxER', label: 'RxER', trigger: 'RxER' },
        { value: 'Health Plus', label: 'Health Plus', trigger: 'Health_Plus' },
        { value: 'Health Check', label: 'Health Check', trigger: 'Health_Check' },
        { value: 'My Medicard', label: 'My Medicard', trigger: 'My_Medicard' },
      ],
      placeholder: "Choose an answer"
    },
    {
      id: "RxER",
      component: <div className="bot-message-component"  style={{textAlign: "left", textJustify:"inner-word"}}>
        <p style={{fontWeight: 'bold',  textAlign: "left"}}>RxER</p>
        Designed to give members utmost value and convenience, 
        RXER offers a specialized healthcare maintenance service that covers emergency for trauma cases, 
        preventive and outpatient care at Medicard free-standing clinics. 
        Best of all, there’s no age limit, no medical check-up required, and hierarchy is waived.  
      <br /> <br />
      Get to know more about RxER at <a target="_blank" rel="noopener noreferrer"  href="https://www.medicardphils.com/healthcare-programs/rxer">https://www.medicardphils.com/healthcare-programs/rxer</a>. <br /><Timestamp />
      </div>,
      asMessage: true,
      trigger: "RxER_Clicked"
    },
    {
      id: "RxER_Clicked",
      options: [{value: 'RxER_Chat_Button', label: 'Chat with an Agent', trigger: 'RxER_Button'}]
    },
    {
      id: "Health_Plus",
      component: <div className="bot-message-component"  style={{textAlign: "left", textJustify:"inner-word"}}>
      <p style={{fontWeight: 'bold',  textAlign: "left"}}>Health Plus</p>
      For only P1,100, get preventive and out-patient coverage in MediCard Free-Standing Clinics (FSCs) for one year.        
      <br /> <br />
      Get to know more about Health Plus at <a target="_blank" rel="noopener noreferrer"  href="https://www.medicardphils.com/healthcare-programs/health-plus">https://www.medicardphils.com/healthcare-programs/health-plus</a>. <br /><Timestamp />
      </div>,
      asMessage: true,
      trigger: "Health_Plus_Clicked"
    },
    {
      id: "Health_Plus_Clicked",
      options: [{value: 'Health_Plus_Chat_Button', label: 'Chat with an Agent', trigger: 'Health_Plus_Button'}]
    },
    {
      id: "Health_Check",
      component: <div className="bot-message-component"  style={{textAlign: "left", textJustify:"inner-word"}}>
      <p style={{fontWeight: 'bold',  textAlign: "left"}}>Health Check</p>
      Get unlimited check-ups for the cost of one consultation fee!  
      The MediCard Health Check card gives you unlimited check-ups with our primary care physicians and select specialists, 
      20% discount on labs and tests, plus one-time annual physical exam—all for only P500. Valid for one year at any 
      MediCard free-standing clinic where the card was bought. Visit any of our <a target="_blank" rel="noopener noreferrer"  href="https://fsc.medicardphils.com/">free-standing clinics</a> to purchase.        
      <br /> <br />
      Get to know more about Health Check at <a target="_blank" rel="noopener noreferrer"  href="https://www.medicardphils.com/healthcare-programs/health-check">https://www.medicardphils.com/healthcare-programs/health-check</a>. <br /><Timestamp />
      </div>,
      asMessage: true,
      trigger: "backButtonNonMember"
    },
    {
      id: "My_Medicard",
      component: <div className="bot-message-component"  style={{textAlign: "left", textJustify:"inner-word"}}>
      <p style={{fontWeight: 'bold',  textAlign: "left"}}>My MediCard</p>
      My MediCard is the ultimate health card for unlimited check-ups with select MediCard-accredited doctors. 
      It also comes with a one-time oral prophylaxis. Sold for only P3,600 and membership is already good for one year. 
      <br /> <br />
      Get to know more about My Medicard at <a target="_blank" rel="noopener noreferrer"  href="https://www.medicardphils.com/healthcare-programs/my-medicard">https://www.medicardphils.com/healthcare-programs/my-medicard</a>. <br /><Timestamp />
      </div>,
      asMessage: true,
      trigger: "backButtonNonMember"
    },

    // OFW Beneficiaries
    {
      id: 'OFW Beneficiaries',
      options: [
        { value: 'Medicard Kabayan', label: 'Medicard Kabayan', trigger: 'Medicard_Kabayan' },
        { value: 'Back', label: 'Back', trigger: 'backButtonNonMember'}
      ],
    },
    {
      id: "Medicard_Kabayan",
      component: <div className="bot-message-component"  style={{textAlign: "left", textJustify:"inner-word"}}>
      <p style={{fontWeight: 'bold',  textAlign: "left"}}>Medicard Kabayan</p>
      Created for overseas sponsors, this product provides superior health coverage for beneficiaries in the Philippines. 
      <br /> <br />
      Get to know more about MediCard Kabayan at <a target="_blank" rel="noopener noreferrer"  href=" https://www.medicardphils.com/healthcare-programs/kabayan"> https://www.medicardphils.com/healthcare-programs/kabayan</a>. <br /><Timestamp />
      </div>,
      asMessage: true,
      trigger: "Medicard_Kabayan_Clicked"
    },
    {
      id: "Medicard_Kabayan_Clicked",
      options: [{value: 'Medicard_Kabayan_Chat_Button', label: 'Chat with an Agent', trigger: 'Medicard_Kabayan_Button'}]
    },
    // Medicard Select
    {
      id: "Medicard_Select",
      component: <div className="bot-message-component"  style={{textAlign: "left", textJustify:"inner-word"}}>
      <p style={{fontWeight: 'bold',  textAlign: "left"}}>Medicard Select</p>
      MediCard Select is an innovative solution that allows members of all ages to avail themselves of healthcare coverage 
      for minimum fees and management of fund. Best of all, members only pay for what is utilized and unused funds shall be returned. 
      Browse through our website and see how MediCard Select can benefit you.
      <br /> <br />
      Get to know more about MediCard Select at <a target="_blank" rel="noopener noreferrer"  href=" https://www.medicardphils.com/healthcare-programs/medicard-select"> https://www.medicardphils.com/healthcare-programs/medicard-select</a>. <br /><Timestamp />
      </div>,
      asMessage: true,
      trigger: "Medicard_Select_Clicked"
    },
    {
      id: "Medicard_Select_Clicked",
      options: [{value: 'Medicard_Select_Chat_Button', label: 'Chat with an Agent', trigger: 'Medicard_Select_Button'}]
    },
    //CORPORATE AND SME PLANS
    {
      id: 'Corporate_and_SME_Plans',
      component: <CompanyInformationForm customPlugin={customPlugin}/>,
      waitAction: true,
      replace: true,
      trigger: "SalesSBDButton_Clicked"
    },
    {
      id: "SalesSBDButton_Clicked",
      options: [{value: 'SalesSBDButton_Clicked', label: 'Chat with Corporate Accounts Manager', trigger: 'Corporate_and_SME_Plans_Button'}]
    },
    // Contact Us
    {
      id: "Contact_Us_Categories",
      component: <div><p>Categories:</p></div>,
      trigger: 'Contact_Us_Options'
    },
    {
      id: 'Contact_Us_Options',
      options: [
        { value: 'Sponsorship', label: 'Sponsorship', trigger: 'Marketing Email to Sponsorship' },
        { value: 'Corporate Partnership', label: 'Corporate Partnership', trigger: 'Marketing Email to CP' },
        { value: 'Promos', label: 'Promos', trigger: 'Marketing Email to Promos' },
        { value: 'Events', label: 'Events', trigger: 'Marketing Email to Events' },
        { value: 'Medicard_Number_Inquiry', label: 'Medicard Number Inquiry', trigger: 'Medicard_Number_Inquiry_Clicked' },
      ],
      placeholder: "Choose an answer"
    },
    {
      id: "Marketing Email to Sponsorship",
      component: <div className="bot-message-component"  >
      You may send us an email at <a href="mailto:marketing@medicardphils.com">marketing@medicardphils.com</a>. <br/><br/>
      Stay updated by following us on Facebook at Medicard Philippines and on Instagram at @medicardphils.<br /><Timestamp />
      </div>,
      asMessage: true,
      trigger: "Sponsorship_Clicked"
    },
    {
      id: "Marketing Email to CP",
      component: <div className="bot-message-component"  >
      You may send us an email at <a href="mailto:marketing@medicardphils.com">marketing@medicardphils.com</a>. <br/><br/>
      Stay updated by following us on Facebook at Medicard Philippines and on Instagram at @medicardphils.<br /><Timestamp />
      </div>,
      asMessage: true,
      trigger: "Corporate_Partnership_Clicked"
    },
    {
      id: "Marketing Email to Promos",
      component: <div className="bot-message-component"  >
      You may send us an email at <a href="mailto:marketing@medicardphils.com">marketing@medicardphils.com</a>. <br/><br/>
      Stay updated by following us on Facebook at Medicard Philippines and on Instagram at @medicardphils.<br /><Timestamp />
      </div>,
      asMessage: true,
      trigger: "Promos_Clicked"
    },
    {
      id: "Marketing Email to Events",
      component: <div className="bot-message-component"  >
      You may send us an email at <a href="mailto:marketing@medicardphils.com">marketing@medicardphils.com</a>. <br/><br/>
      Stay updated by following us on Facebook at Medicard Philippines and on Instagram at @medicardphils.<br /><Timestamp />
      </div>,
      asMessage: true,
      trigger: "Events_Clicked"
    },
    {
      id: "Sponsorship_Clicked",
      options: [{value: 'Contact_Us_Chat_Button', label: 'Chat with an Agent', trigger: 'Sponsorship_Button'}]
    },
    {
      id: "Corporate_Partnership_Clicked",
      options: [{value: 'Contact_Us_Chat_Button', label: 'Chat with an Agent', trigger: 'Corporate_Partnership_Button'}]
    },
    {
      id: "Promos_Clicked",
      options: [{value: 'Contact_Us_Chat_Button', label: 'Chat with an Agent', trigger: 'Promos_Button'}]
    },
    {
      id: "Events_Clicked",
      options: [{value: 'Contact_Us_Chat_Button', label: 'Chat with an Agent', trigger: 'Events_Button'}]
    },
    {
      id: "Medicard_Number_Inquiry_Clicked",
      component: <div>Please wait, we will connect you to our agent...<br /><Timestamp /></div>,
      asMessage: true,
      trigger: "Medicard_Number_Inquiry_Button"
    },

    //CHAT WITH AGENT BUTTONS (NON MEMBER)
    {
      id: "SalesIFVButton",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    {
      id: "SalesSelectButton",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    {
      id: "MarketingQueue",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    {
      id: "CMGQueue",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    {
      id: "MedOpsQueue",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    {
      id: "SalesSBDButton",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    //NON-MEMBER BUTTONS
    {
      id: "Individual_and_Family_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    {
      id: "VIP_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    {
      id: "RxER_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    {
      id: "Medicard_Number_Inquiry_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: () => {
        if (window._genesys.widgets.webchat.userData.chooseAnswer === 'Yes') {
          return "memberCategoriesQuestion"
        } else {
          return "nonMemberCategoriesQuestion"
        }
      },
    },
    {
      id: "Medicard_Select_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    {
      id: "Health_Plus_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    {
      id: "Medicard_Kabayan_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    {
      id: "Corporate_and_SME_Plans_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "nonMemberCategoriesRender"
    },
    {
      id: "Sponsorship_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    {
      id: "Corporate_Partnership_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    {
      id: "Promos_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    {
      id: "Events_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    //MEMBER BUTTONS
    // {
    //   id: "Request_approval_for_Laboratory_Diagnostic_test_Button",
    //   component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
    //   trigger: "privacyPolicy"
    // },
    // {
    //   id: "Request_approval_for_Consultation_Button",
    //   component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
    //   trigger: "privacyPolicy"
    // },
    {
      id: "Membership_coverage_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    {
      id: "Membership_information_and_utilization_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
    // {
    //   id: "Online_Consultation_Button",
    //   component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
    //   trigger: "privacyPolicy"
    // },
    {
      id: "Inpatient_Inquiry_and_concerns_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: 'memberCategoriesQuestion'
    },
    {
      id: "Dental_Coverage_and_Concern_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"      
    },
    {
      id: "Sponsorships_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"     
    },
    {
      id: "Partnerships_Button",
      component: <SpeakWithAgentButton handleInLiveChatInSession={handleInLiveChatInSession} setIsLiveChatinSession={setIsLiveChatinSession} setOpened={setOpened}  customPlugin={customPlugin}  />,
      trigger: "privacyPolicy"
    },
  ];

  customPlugin && customPlugin.subscribe('WebChatService.ended', function (e) {
    customPlugin.command('WebChat.close')
    setIsLiveChatinSession(true)
    setOpened(!opened);
  });

  return (
    <>
      {
        isLiveChatinSession &&
        <ChatBotDiv className='open-chatbot' onClick={() => handleOpenChatBot()}>
          <ChatBotImg src='/wp-content/uploads/2023/09/chat.svg' alt='Chat bot' />
        </ChatBotDiv>
      }
      <ThemeProvider theme={theme} >
        <ChatBot 
          steps={steps}
          headerComponent={<Header closeChatBot={handleOpenChatBot}/>}
          toggleFloating={opened}
          {...config}
          opened={opened}
        />
      </ThemeProvider>
    </>
    
  )
}

export default MedicardChatBot;
